module.exports = __webpack_public_path__ + "img/no_audition.70b5a49c.png";